import React from 'react';
import { ChecklistCollection as ChecklistCollectionDisplay } from '@corti/corti-ui';
import { ChecklistUIProvider } from '../data/ChecklistUIProvider';
import { Checklist } from './Checklist';
export function ChecklistCollection({ checklists, listener }) {
    return (React.createElement(ChecklistUIProvider, { listener: listener },
        React.createElement(ChecklistCollectionDisplay, null, checklists.map((checklist) => (React.createElement(Checklist, { key: checklist.id, actor: checklist.ref }))))));
}
